import React from "react";
import classes from "./ListSteps.module.scss";
import ImgArrow from "./ImgArrow.png";

export default function ListSteps({
  steps,
  centerVert,
  className = "",
}: {
  className?: string;
  centerVert?: boolean;
  steps?: Array<string> | null;
}) {
  const getSteps = (steps: Array<string>) => {
    return steps.map((step, index) => (
      <li className={classes.Step} key={"" + index + 1 + Math.random() + step}>
        <p className={classes.StepIndex}>{index + 1}</p>
        <div className={classes.InfosArea}>
          <div className={classes.Info}>
            {step}
            <figure className={classes.ImgArrow}>
              <img src={ImgArrow} alt="" />
            </figure>
          </div>
        </div>
      </li>
    ));
  };

  // =====================
  //       Styling
  // =====================

  className += " " + classes.ListSteps;
  if (centerVert) className += " " + classes.CenterVert;

  let _content = null;
  if (steps) {
    const stepsRows = getSteps(steps);
    _content = <ul className={className}>{stepsRows}</ul>;
  }
  return _content;
}
